import React from 'react';
import { GiftIcon } from 'lucide-react';
interface FreeGiftBannerProps {
  giftProduct?: {
    name: string;
    price: number;
    image: string;
  };
}
export function FreeGiftBanner({
  giftProduct
}: FreeGiftBannerProps) {
  const defaultGift = {
    name: 'Dyson Corrale Hair Straightener Copper',
    price: 1899.0,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aXGN1iobmEk6VZbAJsTdpv/image.png'
  };
  const gift = giftProduct || defaultGift;
  return <div className="bg-gradient-to-r from-emerald-50 to-green-50 border-2 border-emerald-200 rounded-xl p-4 mb-4" data-id="element-4850" data-mp="2pw8np5ckz42x">
      {/* Header with gift icon and text */}
      <div className="flex items-center gap-2 mb-3" data-id="element-4851" data-mp="34v2muqd7lnag">
        <GiftIcon className="w-5 h-5 text-emerald-600 flex-shrink-0" data-id="element-4852" data-mp="2ztvgmvqpsw5w" />
        <p className="text-sm font-bold text-emerald-800" data-id="element-4853" data-mp="2zwrfqneatqvx">
          Free Gift — Product will be added to cart automatically
        </p>
      </div>
      {/* Gift product details */}
      <div className="flex items-center gap-3 bg-white rounded-lg p-3 border border-emerald-100" data-id="element-4854" data-mp="f3wdr0oj1da5">
        {/* Product Image */}
        <div className="flex-shrink-0 w-16 h-16 bg-gray-50 rounded-lg overflow-hidden" data-id="element-4855" data-mp="1hhcng3cscjxl">
          <img src={gift.image} alt={gift.name} className="w-full h-full object-contain" data-id="element-4856" data-mp="1hj5xlsmlxmac" />
        </div>
        {/* Product Info */}
        <div className="flex-1 min-w-0" data-id="element-4857" data-mp="1qh82ij9goz2w">
          <h4 className="text-sm font-medium text-gray-900 mb-1 line-clamp-2" data-id="element-4858" data-mp="ts0e93hgkbva">
            {gift.name}
          </h4>
          <p className="text-base font-bold text-emerald-600" data-id="element-4859" data-mp="yq1wxnaz2968">
            SAR {gift.price.toFixed(2)}
          </p>
        </div>
      </div>
    </div>;
}